import { createFilledIcon } from "../createIcon";

export const IPhoneFilledIcon = createFilledIcon(
  <>
    <path d="M4.8 5.6c0-1.767 1.382-3.2 3.087-3.2h8.228c1.704 0 3.086 1.433 3.086 3.2v12.8c0 1.767-1.382 3.2-3.086 3.2H7.887c-1.705 0-3.086-1.433-3.086-3.2V5.6Zm4.63 0c-.569 0-1.03.477-1.03 1.067 0 .589.461 1.066 1.03 1.066h5.142c.568 0 1.029-.477 1.029-1.066 0-.59-.46-1.067-1.029-1.067H9.43ZM12 16.267c-.567 0-1.028.477-1.028 1.066v.069c0 .589.46 1.066 1.029 1.066h.073c.568 0 1.028-.477 1.028-1.066v-.069c0-.589-.46-1.066-1.028-1.066H12Z" />
  </>,
  "IPhoneFilledIcon"
);
